import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCallback } from "react";

import { addToast, nextId } from "shared/actions/toastActions";

import { useAppDispatch } from "store/hooks";

/**
 * Writes `block-{id}` to the clipboard and shows a toast. Returns a stable
 * callback safe to pass to onClick handlers (e.g. Menu.Item).
 */
export const useCopyBlockId = () => {
  const dispatch = useAppDispatch();
  const errorToast = (block_id: number) => {
    dispatch(
      addToast(
        {
          kind: "danger",
          message: `Failed to copy block-${block_id}`,
        },
        nextId()
      )
    );
  };

  return useCallback(
    (block_id: number) => {
      if (!navigator.clipboard?.writeText) {
        errorToast(block_id);

        return;
      }

      navigator.clipboard
        .writeText(`block-${block_id}`)
        .then(() => {
          dispatch(
            addToast(
              {
                kind: "success",
                message: `Copied block-${block_id}`,
                removalTimeout: 2000,
              },
              nextId()
            )
          );
        })
        .catch(() => {
          errorToast(block_id);
        });
    },
    [dispatch]
  );
};

const CopyBlockButton = ({ block_id }: { block_id: number }) => {
  const copyBlockId = useCopyBlockId();

  return (
    <button
      type="button"
      onClick={() => copyBlockId(block_id)}
      className="PWTable__actions__button pwButton--grey copyBlockButton"
      title={`Copy block-${block_id}`}
    >
      <FontAwesomeIcon icon="copy" />
    </button>
  );
};

export default CopyBlockButton;
